export default __webpack_public_path__ + "static/media/questionMark.97e1b757.svg";